<div class="container">
  <div class="pt-2">
    <h1 class="page-title">{{heading1}}</h1>
  </div>
  @if (!isKbUser) {
    <div  class="hover-red">
      <a tabindex="0" class="hover-red btn btn-link" (click)="onPrevious()">
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16.875" height="15.75" viewBox="0 0 16.875 15.75">
          <g id="_icons_arrow-back-outline" data-name="⚛️ icons/arrow-back-outline" transform="translate(0)">
            <path id="Combined_Shape" data-name="Combined Shape"
              d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
              transform="translate(0)" fill="#174a7c" />
            </g>
          </svg>
          <span class="ps-2">Back to TennCare Access Welcome Page</span>
        </a>
      </div>
    }
    <div class="container">
      <div class="row py-4">
        <div class="card">
          <div class="page_label p-4">
            <h2 class="section-header">{{heading2}}</h2><hr>
            @if (!memberAccessDashboard) {
              <p>{{heading3}}</p>
            }
            <div  [ngClass]="{'dataBox': memberAccessDashboard}" >
              @if (memberAccessDashboard) {
                <h3 class="section-header">Member Search</h3>
              }
              @if (memberAccessDashboard) {
                <p [innerHTML]="heading3"></p>
              }
              <nh-alert type="warning" [isOpen]="bccTreatment && duplicateWarning">
                <div class="row">
                  <div class="col-auto icon">
                    <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg" alt="warning" />
                  </div>
                  <div class="col message">
                    <span>A BCC Treatment Plan Extension request was already submitted for this member on {{submittedDate}}. Do you want to submit another request?</span>
                  </div>
                </div>
              </nh-alert>
              <br>
                <form [formGroup]="memberSearchForm">
                  <div class="row g-3">
                    <div class="col-sm-12 col-md-6">
                      <nh-field label="Date of Birth" class="label-section">
                        <nh-datepicker>
                          <input id = "ms_dateOfBirth" type="text" class="form-control" [attr.disabled]="isKbUser ? true : null" name="dateOfBirth"
                            formControlName="dateOfBirth" aria-label="dateOfBirth" placeholder="mm/dd/yyyy" [minDate]="minimumDate" [maxDate]="today"
                            bsDatepicker nh required>
                          </nh-datepicker>
                        </nh-field>
                      </div>
                    </div>

                    <div class="row g-3">
                      <div class="col-5 col-md-5 d-none d-sm-block">
                        <p class="and-border"></p>
                      </div>
                      <div class="col-md-2 col-sm-12">
                        <p class="text-center"><strong>AND</strong></p>
                      </div>
                      <div class="col-5 col-md-5 d-none d-sm-block">
                        <p class="and-border"></p>
                      </div>
                    </div>
                    <div class="row g-3">
                      <div class="col-sm-12 col-md-3">
                        <nh-field [attr.aria-required]="true" id = "ms_dateOfBirth" [mandatory]="true" [isRow]="true" label="Social Security Number" class="label-section">
                          <input type="text" name="ssn" formControlName="ssn" class="form-control" placeholder="XXX-XX-XXXX" mask="000-00-0000">
                        </nh-field>
                      </div>
                      <div class="col-sm-12 col-md-1">
                        <p class="text-center pt-4 mt-2"><strong>OR</strong></p>
                      </div>
                      <div class="col-sm-12 col-md-5">
                        <nh-field [attr.aria-required]="true" [mandatory]="true" label="Person ID" class="label-section">
                          <input id="ms_personID" type="text" [attr.disabled]="isKbUser ? true : null" name="personID"
                            formControlName="personID" class="form-control" mask="9999999999" aria-label="Person ID">
                          </nh-field>
                        </div>
                      </div>
                      <div class="row g-3 py-2">
                        <div class="d-flex">
                          <div>
                            <nh-checkbox name="applicantBehalf" [index]="'ms-'" [control]="memberSearchForm.controls['applicantBehalf']" checkedValue='checked' [mandatory]="false"></nh-checkbox>
                            <label class="visually-hidden" for="checkbox-ms-applicantBehalf">{{heading4}}</label>
                          </div>
                          <div>
                            @if (this.bccTreatment || mPLogin || memberAccessDashboard) {
                              <span aria-hidden="true" class="requiredfd">*</span>
                              }{{heading4}}
                            </div>
                          </div>
                        </div>
                      </form>
                      <br>
                        <div class="row g-3">
                          @if (!imeSubmission && !mPLogin && !memberAccessDashboard) {
                            <div class="col-12 col-md-3 py-2 py-md-0 order-md-1">
                              <button class="btn btn-secondary" (click)="onSearch()" style="text-transform: initial"
                                [disabled]="memberSearchForm.invalid">
                                Search&nbsp; <i class="fa fa-search"></i>
                              </button>
                            </div>
                          }
                          @if (imeSubmission || mPLogin || memberAccessDashboard) {
                            <div class="col-12 col-md-3 py-2 py-md-0 order-md-1">
                              <button class="btn btn-secondary" (click)="onSearch()" style="text-transform: initial"
                                [disabled]="memberSearchForm.invalid">
                                Search Member&nbsp; <i class="fa fa-search"></i>
                              </button>
                            </div>
                          }
                        </div>
                        <br>
                          @if (memberAccessDashboard && !rows && isSearchCompleted) {
                            <div>
                              @if (!displayKnownToTEDSMessage) {
                                <p>Your search did not return any results. Please try different criteria and search again.</p>
                              }
                              @if (displayKnownToTEDSMessage) {
                                <p>This member cannot be added to your dashboard at this time. Use View TennCare Connect to see their coverage details.</p>
                              }
                            </div>
                          }

                          @if (rows && isSearchCompleted) {
                            <div>
                              @if (!memberAccessDashboard) {
                                <h3 class="section-header">Search Results</h3>
                                }<hr>
                                @if (rows && !imeSubmission && !mPLogin) {
                                  <ngx-datatable class='bootstrap striped' #table [rows]='rows' columnMode="force" [headerHeight]='50' [footerHeight]='50' [rowHeight]='"auto"' [limit]="5">
                                    @for (col of columns; track col) {
                                      <ngx-datatable-column [name]="col.name" [prop]="col.prop"></ngx-datatable-column>
                                    }
                                    @if (!memberAccessDashboard) {
                                      <ngx-datatable-column  name="Select" [width]="180">
                                        <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                          <div class="d-flex" tabindex="0" >
                                            @if (this.isFinReacess && isSearchCompleted && isMedicaidEligible) {
                                              <a class="view-tennCare-title">
                                                <span (click)="startReassessment(row)">Start Financial Reassessment for Medicaid</span>
                                              </a>
                                            }
                                            @if (this.isFinReacess && isSearchCompleted && !isMedicaidEligible) {
                                              <div>
                                                <p><strong>Stop</strong> This form can't be submitted because this person is not receiving
                                                Institutional Medicaid coverage. Fill out an application and tell us this person needs nursing home care.
                                              </p>
                                            </div>
                                          }
                                          @if (this.bccTreatment && isSearchCompleted && isMedicaidEligible) {
                                            <a tabindex="0" class="view-tennCare-title">
                                              <span (click)="startBccExtension(row)">Start BCC Treatment Plan Extension Request</span>
                                            </a>
                                          }
                                          @if (this.bccTreatment && isSearchCompleted && !isMedicaidEligible) {
                                            <div>
                                              <p>This form can’t be submitted because this person is not pending for BCC Coverage. Fill out an application and tell us this person needs BCC Coverage.
                                              </p>
                                            </div>
                                          }
                                          @if (!this.isFinReacess && !this.bccTreatment && !this.readTCC) {
                                            <a tabindex="0" class="view-tennCare-title">
                                              <span (click)="toTenncare(row.personId)">View TennCare Connect</span>
                                            </a>
                                          }
                                          @if (this.readTCC) {
                                            <a tabindex="0" class="view-tennCare-title">
                                              <span (click)="toReadTenncare(row.personId)">View TennCare Connect (View Only)</span>
                                            </a>
                                            }&nbsp;&nbsp;
                                            @if (isMedicaidEligible || (!this.isFinReacess && !this.bccTreatment)) {
                                              <span class="ps-1"><i class="fa fa-external-link view-tennCare-title"></i></span>
                                            }
                                          </div>
                                        </ng-template>
                                      </ngx-datatable-column>
                                    }
                                    @if (memberAccessDashboard) {
                                      <ngx-datatable-column  name="Action" [width]="180">
                                        <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                          @if (row.action) {
                                            <div class="d-flex">
                                              <button class="btn btn-sm btn-secondary mb-1 w-70 edit" (click)="addRemoveMembers(row, 'add')" >Add Member <svg id="_icons_add-circle-outline" data-name="⚛️ icons/add-circle-outline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path id="Combined_Shape" data-name="Combined Shape" d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z" transform="translate(2.25 2.25)" fill="#174a7c"/>
                                              </svg></button>
                                            </div>
                                          }
                                          @if (!row.action) {
                                            <div class="d-flex"><p>You have already added this member to your dashboard under <b>My Added Members.</b></p></div>
                                          }
                                        </ng-template>
                                      </ngx-datatable-column>
                                    }
                                  </ngx-datatable>
                                }
                                @if (rows && imeSubmission) {
                                  <ngx-datatable class='bootstrap striped ime-table-small' #table [rows]='rows' columnMode="force" [headerHeight]='50' [footerHeight]='50' [rowHeight]='"auto"' [limit]="5">
                                    @for (col of imeColumns1; track col) {
                                      <ngx-datatable-column [name]="col.name" [prop]="col.prop"></ngx-datatable-column>
                                    }
                                    <ngx-datatable-column name="Living Arrangement" [width]="170">
                                      <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                        <div>
                                          <p class="living">{{ row.livingArrangement}} </p>
                                        </div>
                                      </ng-template>
                                    </ngx-datatable-column>
                                    @for (col of imeColumns2; track col) {
                                      <ngx-datatable-column [name]="col.name" [prop]="col.prop"></ngx-datatable-column>
                                    }
                                    <ngx-datatable-column name="Select" [width]="170">
                                      <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                        <div class="d-flex" tabindex="0" >
                                          @if (this.imeSubmission && isSearchCompleted && row.isMedicaidEligible) {
                                            <a class="view-tennCare-title">
                                              <span (click)="startIMEApplication(row)">Incurred Medical Expenses</span>
                                            </a>
                                            }&nbsp;&nbsp;
                                            @if (this.imeSubmission && isSearchCompleted && row.isMedicaidEligible) {
                                              <span><i class="fa fa-external-link view-tennCare-title"></i></span>
                                            }
                                            @if (this.imeSubmission && isSearchCompleted && !row.isMedicaidEligible) {
                                              <div>
                                                <p class="living">This form can’t be submitted for this case because this person is not eligible to add Incurred Medical Expenses.
                                                </p>
                                              </div>
                                            }
                                          </div>
                                        </ng-template>
                                      </ngx-datatable-column>
                                    </ngx-datatable>
                                  }
                                  @if (rows && mPLogin && !noTccAccount) {
                                    <ngx-datatable class='bootstrap striped' #table [rows]='rows' columnMode="force" [headerHeight]='50' [footerHeight]='50' [rowHeight]='"auto"' [limit]="5">
                                      @for (col of mplColumns; track col) {
                                        <ngx-datatable-column [name]="col.name" [prop]="col.prop"></ngx-datatable-column>
                                      }
                                      <ngx-datatable-column name="Select" [width]="180">
                                        <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                          <div class="d-flex" tabindex="0">
                                            <a class="view-tennCare-title">
                                              <span (click)="toMPLoginDetails(row)">Access Member Portal Login </span>
                                            </a>
                                            <span><i class="fa fa-external-link view-tennCare-title"></i></span>
                                          </div>
                                        </ng-template>
                                      </ngx-datatable-column>
                                    </ngx-datatable>
                                  }
                                  <ngx-datatable-footer>
                                    <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount"
                                      let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
                                      <div class="container" ></div>
                                    </ng-template>
                                  </ngx-datatable-footer>
                                </div>
                              }
                            </div>
                            @if (memberAccessDashboard && addedMembers && addedMembers.length) {
                              <br>
                              }
                              @if (memberAccessDashboard && addedMembers && addedMembers.length) {
                                <div [ngClass]="{'dataBox': memberAccessDashboard}">
                                  <h3 class="section-header"> My Added Members</h3>
                                  <p>Here are the members you added to your Member Assistance Dashboard. To add additional members, use the Member Search.</p><br>
                                  <ngx-datatable class='bootstrap striped' #table [rows]='addedMembers' columnMode="force" [headerHeight]='50' [footerHeight]='50' [rowHeight]='"auto"' [limit]="7" >
                                    @for (col of columns; track col) {
                                      <ngx-datatable-column [name]="col.name" [prop]="col.prop"></ngx-datatable-column>
                                    }
                                    @if (memberAccessDashboard) {
                                      <ngx-datatable-column  name="Action" [width]="180"  [headerClass]="'action-padding-left'">
                                        <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                          <div class="hover-red">
                                            <a tabindex="0" class="hover-red btn btn-link" (click)="addRemoveMembers(row, 'remove')">
                                              <span class="pe-2">Remove</span>
                                              <nh-remove-svg id="mobile_count"></nh-remove-svg>
                                            </a>
                                          </div>
                                        </ng-template>
                                      </ngx-datatable-column>
                                    }
                                  </ngx-datatable>
                                  <div style="text-align: center;">
                                    <button class="btn btn-secondary" (click)="viewDashboard()" style="text-transform: uppercase; width: 400px;">
                                      View Member Assistance Dashboard
                                    </button>
                                  </div>
                                </div>
                              }

                              @if (rows && rows.length && !memberAccessDashboard) {
                                <div class="pull-right">
                                  <p>Results Shown {{rows.length}}</p>
                                </div>
                              }
                              @if (rows && !rows.length && !mPLogin) {
                                <div>
                                  @if (!this.isFinReacess && !bccTreatment && !imeSubmission) {
                                    <p>Your search did not return any results. Please try different criteria and search again.</p>
                                  }
                                  @if (this.isFinReacess) {
                                    <p>We could not find the person you searched for. If this person is not enrolled in TennCare, please <a class="btn-link afb-btn" (click)="startApp('AFB')">Apply For Coverage</a>.</p>
                                  }
                                  @if (bccTreatment) {
                                    <p>We could not find the person you searched for. If this person is not enrolled in TennCare, please complete the <a class="btn-link afb-btn" (click)="startApp('BCC')"><strong>Presumptive BCC Application.</strong></a></p>
                                  }
                                  @if (imeSubmission && !showTable) {
                                    <p>We could not find the person you searched for. If this person is not enrolled in TennCare, please complete the <a class="btn-link afb-btn" (click)="startApp('AFB')"><strong>Full Coverage Application.</strong></a></p>
                                  }
                                </div>
                              }
                              @if (mPLogin) {
                                <div>
                                  @if (rows && rows.length === 0) {
                                    <p>Your search did not return any results. Please try different criteria and search again.</p>
                                  }
                                  @if (noTccAccount && !rows) {
                                    <p>The member you have searched for does not have a linked TennCare Connect account.</p>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>